export default "__VITE_ASSET__DqoPAXKR__"